<template>
  <sp-text :tag="tag" class="sp-title" type="title">
    <slot />
  </sp-text>
</template>

<script setup>
defineProps({
  tag: {
    type: String,
    default: "div",
  },
});
</script>

<style>
:host {
  display: block;
  margin: 0;
}
</style>
